import { RequestsApi } from '../RequestsApi';

class AuthApi extends RequestsApi {
    async getUser() {
        return await this.request('/user', 'GET');
    }
    async updateUser(props) {
        return await this.request('/user', 'post', props);
    }

    async deleteUser() {
        return await this.request('/user', 'delete');
    }

    async getUserLocation(search) {
        return await this.request('/user/location', 'post', { input: search });
    }

    async userLogout() {
        return await this.request('/user/logout', 'post');
    }
}

export default new AuthApi();
